import React from 'react';
import { Users, TrendingUp, Activity, DollarSign } from 'lucide-react';
import './Dashboard.css';

const Dashboard = () => {
  const stats = [
    {
      title: 'Total Users',
      value: '1,234',
      change: '+12%',
      changeType: 'positive',
      icon: Users,
      color: '#3b82f6',
    },
    {
      title: 'Active Sessions',
      value: '567',
      change: '+8%',
      changeType: 'positive',
      icon: Activity,
      color: '#10b981',
    },
    {
      title: 'Revenue',
      value: '$12,345',
      change: '+15%',
      changeType: 'positive',
      icon: DollarSign,
      color: '#f59e0b',
    },
    {
      title: 'Growth Rate',
      value: '23.5%',
      change: '+2.1%',
      changeType: 'positive',
      icon: TrendingUp,
      color: '#8b5cf6',
    },
  ];

  const recentActivity = [
    { id: 1, action: 'New user registered', time: '2 minutes ago', type: 'user' },
    { id: 2, action: 'System backup completed', time: '15 minutes ago', type: 'system' },
    { id: 3, action: 'Payment processed', time: '1 hour ago', type: 'payment' },
    { id: 4, action: 'Database updated', time: '2 hours ago', type: 'system' },
    { id: 5, action: 'User profile updated', time: '3 hours ago', type: 'user' },
  ];

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h2>Dashboard</h2>
        <p>Welcome back! Here's what's happening with your system today.</p>
      </div>

      <div className="stats-grid">
        {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div key={index} className="stat-card">
              <div className="stat-icon" style={{ backgroundColor: stat.color }}>
                <Icon size={24} color="white" />
              </div>
              <div className="stat-content">
                <h3 className="stat-title">{stat.title}</h3>
                <p className="stat-value">{stat.value}</p>
                <span className={`stat-change stat-change-${stat.changeType}`}>{stat.change}</span>
              </div>
            </div>
          );
        })}
      </div>

      <div className="dashboard-content">
        <div className="content-grid">
          <div className="content-card">
            <h3>Recent Activity</h3>
            <div className="activity-list">
              {recentActivity.map((activity) => (
                <div key={activity.id} className="activity-item">
                  <div className={`activity-dot activity-dot-${activity.type}`}></div>
                  <div className="activity-content">
                    <p className="activity-action">{activity.action}</p>
                    <span className="activity-time">{activity.time}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="content-card">
            <h3>Quick Actions</h3>
            <div className="quick-actions">
              <button className="action-button">
                <Users size={16} />
                Manage Users
              </button>
              <button className="action-button">
                <Activity size={16} />
                View Analytics
              </button>
              <button className="action-button">
                <DollarSign size={16} />
                Financial Report
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
